export default "__VITE_ASSET__DJnM2zcE__"